import * as React from "react"
import {Box, Typography} from "@mui/material";


export default function MuiTableTitleSeeker({ title, subtitle, ...props }) {
	return <Box>
		<Typography variant="h5" {...props}>
			{title}
		</Typography>
		{ !!subtitle && <Typography variant="body1" {...props?.subtitleProps} sx={{ color: "text.secondary", ...props?.subtitleProps?.sx }}>
			{subtitle}
		</Typography> }
	</Box>
}
